import { useQuery } from '@tanstack/react-query';
import { RorosTreeService } from '@/services/roros/tree.service';
import { rorosKeys } from './keys';

const STALE_TIME = 2 * 60_000;
const GC_TIME = 5 * 60_000;

export function useRorosTree(params?: { includeWorkItems?: boolean }) {
  return useQuery({
    queryKey: [...rorosKeys.tree.all, params] as const,
    queryFn: () =>
      RorosTreeService.getTree({
        include_work_items: params?.includeWorkItems ?? false,
      }),
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}
